import { AssetType } from '../../../../../utils/storage';
import MediaRenderer from '../../../../core/components/MediaRenderer';

interface SectionMediaProps {
    media: AssetType | null
    style?: object,
}

export default function ActivityMedia({ media, style = {} }: SectionMediaProps) {
    if (!media) {
        return null;
    }

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                ...style,
            }}
        >
            <MediaRenderer
                media={media}
                cover="fill"
                toApplyInternalEffect
                delayInternalEffect={0}
            />
        </div>
    );
}
